import React from "react";
import { Link } from "react-router-dom";
import "../assets/styles/Footer.css";

function Footer() {
  return (
    <footer className="bg-light py-5 mt-5 border-top">
      <div className="container">
        <div className="row">
          <div className="col-md-3 mb-4">
            <h5 className="fw-bold">Sana</h5>
            <p className="text-muted">Tu sonrisa es nuestra pasión. Clínica dental en Orizaba con servicios de vanguardia.</p>
            <div className="d-flex gap-3">
              <a href="https://www.facebook.com/share/19snh9vM7J/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer" className="text-dark">
                <i className="bi bi-facebook fs-4"></i>
              </a>
              <a href="https://www.instagram.com/ortodoncia_sana?igsh=YWhyNzRudHNpMmNz" target="_blank" rel="noopener noreferrer" className="text-dark">
                <i className="bi bi-instagram fs-4"></i>
              </a>
              <a href="https://www.tiktok.com/@jcgsana?is_from_webapp=1&sender_device=pc" target="_blank" rel="noopener noreferrer" className="text-dark">
                <i className="bi bi-tiktok fs-4"></i>
              </a>
            </div>
          </div>

          <div className="col-md-3 mb-4">
            <h6 className="fw-bold">Enlaces Rápidos</h6>
            <ul className="list-unstyled">
              <li><a href="#inicio" className="text-muted">Inicio</a></li>
              <li><a href="#servicios" className="text-muted">Servicios</a></li>
              <li><a href="#ubicacion" className="text-muted">Ubicación</a></li>
              <li><a href="#opiniones" className="text-muted">Opiniones</a></li>
              <li><a href="#redes" className="text-muted">Redes</a></li>
              <li><a href="#portafolio" className="text-muted">Galería</a></li>
            </ul>
          </div>

          <div className="col-md-3 mb-4">
            <h6 className="fw-bold">Legal</h6>
            <ul className="list-unstyled">
              <li><Link to="/aviso-privacidad" className="text-muted">Aviso de Privacidad</Link>.</li>
              <li><Link to="/terminos-condiciones" className="text-muted">Términos y condiciones</Link></li>
            </ul>
          </div>

          <div className="col-md-3 mb-4">
            <h6 className="fw-bold">Contacto Directo</h6>
            <p className="text-muted mb-1">(272) 198-6870</p>
            <p className="text-muted mb-1">sanaservidental@gmail.com</p>
            <p className="text-muted mb-0"><i className="bi bi-whatsapp"></i> WhatsApp</p>
          </div>
        </div>

        <div className="text-center text-muted small mt-4">
          © 2025 Clínica Dental Sana Orizaba. Todos los derechos reservados. <br />
          Sitio web desarrollado por <strong>DAGS</strong>.
        </div>
      </div>
    </footer>

  );
}

export default Footer;
